export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-connected-dark.1dc036fdb6ad5b2833a866d32c5acd0d.png";